module.exports = __webpack_public_path__ + "img/logo.bc459d76.svg";